import React from 'react'
import MultiColumnGreenCards from './design-components/MultiColumnGreenCards';
import MultiColumns from './design-components/MultiCards';

interface HealthcareProps {
    data: any;
    title: string;
}

const Healthcare = ({
    title,
    data
}: HealthcareProps) => {
    return (
        <div className="flex flex-col h-full items-center">
            <h1 className="relative inline-block text-white text-center font-extrabold 
  max-w-4xl text-2xl lg:text-4xl font-nunito mb-2 
  bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
  px-6 py-2
  before:content-[''] before:absolute before:left-0 before:top-1/2 
  before:-translate-y-1/2 before:-translate-x-full
  before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
  before:border-r-[#92D050]

  after:content-[''] after:absolute after:right-0 after:top-1/2 
  after:-translate-y-1/2 after:translate-x-full
  after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
  after:border-l-[#8CC54F]">
                {title}
            </h1>
            <MultiColumns data={data} />
        </div>
    )
}

export default Healthcare
